import { optionsToStrategy } from '@/common/utils/optionsToStrategy';

export const options = [
  { label: 'Nenhum', value: 'none' },
  { label: 'Por nota', value: 'per_transaction' },
  { label: 'Por fatura', value: 'per_bill' },
];

export const strategy = optionsToStrategy(options);
